module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-vi-VN.9349687d.jpg";